import { render } from "./AgSegmentRegComponent.vue?vue&type=template&id=5c8da5ea&scoped=true&ts=true"
import script from "./AgSegmentRegComponent.vue?vue&type=script&lang=ts"
export * from "./AgSegmentRegComponent.vue?vue&type=script&lang=ts"

import "./AgSegmentRegComponent.vue?vue&type=style&index=0&id=5c8da5ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8da5ea"]])

export default __exports__